<app-list-view
  [column]="column"
  [data]="inspections"
  [count]="this.count"
  [title]="'Inspections'"
  [url]="url"
  [loading]="loading"
  [hideTabs]="false"
  [SearchPlaceholder]="this.isVendor ? 'Search' : 'Filter by Customer or Policy'"
  [setInspectionSearch]="this.isVendor ? false : true"
  [canEdit]="canAdd"
  [showAction]="true"
  [tabType]="'completed'"
  [actions]="actions"
  [tableName]="'inspectionCompleted'"
  (filters)="loadData($event)"></app-list-view>
